import { Injectable } from '@angular/core';
import { ToastService } from '../Toast/toast.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../Model/utility/utility.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  public User: any = null;
  constructor(
    private toast: ToastService,
    private router: Router,
    private http: HttpClient,
    private modalService: NgbModal,
  ) { }

  // Start(UserData: any) {
  //   // store user details and jwt token in session storage to keep user logged in between page refreshes
  //   return this.SetUserDetails(UserData);
  // }

  async Start(userData: any): Promise<boolean> {
    return this.setUserDetails(userData);
  }

  End() {
    environment.VersionExist = true;
    environment.LastVersionCheck = '';
    sessionStorage.removeItem('User');
    //this.toast.showMessage("Success! You are successfully logged out");
    this.router.navigate(['/login']);
  }

  // SetUserDetails(User: any) {
  //   sessionStorage.setItem('User', JSON.stringify(User));
  //   return true;
  // }

  setUserDetails(user: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        sessionStorage.setItem('User', JSON.stringify(user));
        resolve(true);
      } catch (error) {
        reject(new Error('Failed to store user data in sessionStorage'));
      }
    });
  }

  GetUserDetails() {
    this.User = (JSON.parse(sessionStorage.getItem('User')!));
    return this.User;
  }

  // async GetUserDetails(): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       const userData = sessionStorage.getItem('User');
  //       if (userData) {
  //         resolve(JSON.parse(userData));
  //       } else {
  //         resolve(null);
  //       }
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // }

  SetClass(Details: any) {
    this.User = this.GetUserDetails();
    if (true || this.User.Date == new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear()) {
      if (this.User != null) {
        try {
          if (environment.LastVersionCheck == '' || moment.duration(moment(Date()).diff(environment.LastVersionCheck)).asMinutes() > 10) {
            environment.LastVersionCheck = new Date().toString();
            this.CheckVersionLocks({ ApplicationType: 'ESSWEB', VersionNo: environment.Version, TokenUserName: this.User.TokenUserName, TokenPassword: this.User.TokenPassword, TokenAppName: this.User.TokenAppName, Token: this.User.Token, SessionID: this.User.SessionID, OpType: this.User.OpType, UserType: this.User.UserType, UserId: this.User.UserId, }).subscribe({
              next: (response) => {
                environment.LastVersionCheck = new Date().toString();
                if (response.Error_Code.toLowerCase() == 'error' && environment.VersionExist) {
                  $("app-loader").css("display", "none");
                  environment.VersionExist = false;
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    window.location.reload();
                  });
                }
              },
              complete: () => { },
              error: (error) => {
                environment.LastVersionCheck = new Date().toString();
              },
            });
          }
        } catch (e) { }
        if (this.User != null && environment.VersionExist) {
          Details.TokenUserName = this.User.TokenUserName;
          Details.TokenPassword = this.User.TokenPassword;
          Details.TokenAppName = this.User.TokenAppName;
          Details.Token = this.User.Token;
          Details.SessionID = this.User.SessionID;
          Details.OpType = this.User.OpType;
          Details.UserType = this.User.UserType;
          Details.UserId = this.User.UserId;
          Details.CompanyCode = this.User.CompanyCode;

        }
        return Details;
      } else {
        return Details;
      }
    } else {
      //alert("Session Date Change Please refresh page");
    }
  }

  CheckVersionLocks(Detail: any) {
    try {
      environment.API_URL = this.GetUserDetails().ApiUrl;
    } catch (e) { }

    return this.http.post<any>(environment.API_URL + `CheckVersion/Lock`,
      Detail
    ).pipe(map(response => {
      return response;
    }));
  }
}
